import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const EntrevistasDelete = ({
  id,
  mostrarAlertaTemporal,
  obtenerEntrevistas,
  id_candidato,
  onClose,
  estadoEntrevista,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
//console.log("estadoEntrevista",estadoEntrevista) 
  const interviewStatusUpdate = async () => {
    try {
      const response = await fetch(
        `${UrlApi}/SP_entrevistas/updateAndCheckInterviews/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ aprobado: estadoEntrevista }),
        }
      );

      if (!response.ok) {
        mostrarAlertaTemporal(
          "Hubo un error al cambiar el estado de la entrevista",
          "error"
        );
      }
      mostrarAlertaTemporal(
        "El estado de la entrevista se actualizo correctamente",
        "success"
      );

      await obtenerEntrevistas();
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    try {
      const response = await fetch(
        `${UrlApi}/SP_candidatos/verificarAptitud/${id_candidato}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        mostrarAlertaTemporal(
          `Hubo un error al actualizar el estado del candidato`,
          "error"
        );
      }
      mostrarAlertaTemporal(
        `El estado del candidato se actualizo correctamente`,
        "success"
      );
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    logEventos(
      "Aprobando/Desaprobando entrevistas",
      "Entrevistas",
      "Cambiando el estado de las entrevistas de los candidatos",
      localStorage.getItem("user")
    );

    onClose();
  };
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {estadoEntrevista === 0
                ? "Desaprobar la entrevista" 
                : "Aprobar la entrevista"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          {estadoEntrevista === 0
            ? "¿Esta seguro que quiere desaprobar la entrevista?" 
            : "¿Esta seguro que quiere aprobar la entrevista?"} 
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={interviewStatusUpdate}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default EntrevistasDelete;
